export default __webpack_public_path__ + "static/data-leaders-cd06bdd640b286c60027a716c17e8db2.svg";